
import DetailComponentBase from "@/app/dynamic-components/details/details-components/detail-component.base";
import { DynamicDetailEntry } from "@/app/dynamic-components/details/dynamic-detail.model";
import { DetailContext } from "@/app/contexts/detail.context";
import { Component } from "vue-property-decorator";

export type StateMetaData = {
  selector: string;
  translated: boolean;
  translationKey: string
  color: string;
};

@Component({})
export default class DetailComponentState extends DetailComponentBase<StateMetaData> {
  value: string | null = null;

  postEntityChanged(newValue: DynamicDetailEntry) {
    if (this.detailContext && this.entry) {
      this.value = this.detailContext.resolveFieldValue(this.metadata.selector);
    }
  }

  protected postDetailContextChanged(newValue: DetailContext) {
    if (this.entry && this.detailContext) {
      this.value = this.detailContext.resolveFieldValue(this.metadata.selector);
    }
  }

  get translatedValue() {
    if(!this.value) return this.$t("general.not_available");
    if (!this.metadata.translated && !this.metadata.translationKey) return this.value;
    if(this.metadata.translationKey && this.metadata.translationKey.endsWith('.')) this.metadata.translationKey = this.metadata.translationKey.substring(0,this.metadata.translationKey.length-1);
    if (this.metadata.translationKey) return this.$t(this.metadata.translationKey + '.' + this.value || "general.not_available");
    return this.$t(this.value || "general.not_available");
  }

  get chipColor(): string {
    return this.metadata.color ? this.metadata.color : "primary";
  }
}
